<template>
    <!-- <sa-common-icon-add1 /> -->
    <i v-html="svgCode"></i>
</template>
<script>
    import add1 from '@/packages/svg/icons/common-icon-add/add1';
    export default {
        name: 'saCommonIconAdd1',
        props: {
            config: {
                type: Object,
                default: () => ({
                    // type Theme = 'outline' | 'filled' | 'two-tone';
                })
            },
            theme: {
                type: String,
                default: 'outline',
            },
            strokeLinecap: {
                type: String,
            },
            strokeLinejoin: {
                type: String,
            },
            strokeWidth: {
                type: Number|String,
            }
        },
        computed: {
            svgCode() {
                return add1.render({
                    theme: this.theme,
                    isCurrentColor: true,
                    isFontSize: true
                });
            }
        }
    }
</script>
